import React from 'react'
import BellTopBar from '../../../../../Components/Bars/BellTopBar'
import ProcedureCash from './ProcedureForm/Table'
import CancelBar from '../../../../../Components/Steppers/CancelBar'

const ProcedureCsh = () => {

  return (

    <div className="w-full h-screen  bg-ghost_white">
        <div className="w-full bg-ghost_white">
          <BellTopBar label="Add Procedure" />
          <CancelBar />
        </div>
        <div className='w-10/12 bg-white   overflow-x-hidden overflow-y-auto mx-auto z-20'>
          <ProcedureCash />
        </div>
    </div>
    
  )
}

export default ProcedureCsh